import {type Channel, ChannelType} from '@mattermost/types/channels';

/**
 *
 * @deprecated используйте channel.type === ChannelType.Open
 */
export const isOpenChannel = (channel: Channel | undefined) => {
    return channel?.type === ChannelType.Open;
};
